<template>
  <div>
    <h3>Nouvelle question</h3>
    <mdb-card class="form-card">
      <form @submit.prevent="addQuestion">
        <mdb-card-body>
          <mdb-card-title>Créer une question publique</mdb-card-title>
          <mdb-card-text>Quel est votre question?</mdb-card-text>
          <mdb-input
            ref="questionInput"
            type="textarea"
            :rows="3"
            class="mt-0 mb-3"
            label="Question"
            v-model.trim="question"
            @change="changed"
          ></mdb-input>
          <mdb-card-text>Sélectionnez entre 1 et 5 tags</mdb-card-text>
          <tag-selector class="theme-material" name="tags" v-model="tags" />

          <mdb-alert
            color="success"
            v-if="validatedQuestion && validQuestion"
          >Question ajoutée !</mdb-alert>
          <mdb-alert
            color="danger"
            v-if="validatedQuestion && !validQuestion"
          >Vous devez écrire une question, et lui donner entre 1 et 5 tags.</mdb-alert>

          <mdb-btn type="submit" class="orange darken-1" rounded size="md">Créer</mdb-btn>
        </mdb-card-body>
      </form>
    </mdb-card>
  </div>
</template>

<script>
import TagSelector from "vue-tag-selector";
import {
  mdbListGroup,
  mdbListGroupItem,
  mdbCard,
  mdbCardBody,
  mdbCardTitle,
  mdbAlert,
  mdbCardText
} from "mdbvue";
import { mapState } from "vuex";
export default {
  name: "AddQuestion",
  components: {
    mdbListGroup,
    mdbListGroupItem,
    mdbCard,
    mdbCardBody,
    mdbCardTitle,
    mdbAlert,
    mdbCardText,
    TagSelector
  },
  data() {
    return {
      question: "",
      tags: [],
      validatedQuestion: false,
      validQuestion: false
    };
  },
  methods: {
    addQuestion: async function() {
      if (this.question != "" && this.tags.length > 0 && this.tags.length < 6) {
        this.$store.dispatch("questions/addQuestion", {
          question: this.question,
          tags: this.tags
        });
        this.question = "";

        this.validQuestion = true;
        this.validatedQuestion = true;
      } else {
        this.validQuestion = false;
        this.validatedQuestion = true;
      }
    },
    changed: function() {
      this.validatedQuestion = false;
    }
  }
};
</script>

<style>

</style>